import { PaginationResult } from '../../models';
import { catchError, Observable } from 'rxjs';
import { LegacyBaseApiService } from './legacy-base-api.service';

//NOTE: search API'ında /page url'i bulunan eski API'lar için kullanılan service

export abstract class OldLegacyBaseApiService<T> extends LegacyBaseApiService<T> {
	public override findPageableObjects(
		pageNumber: number,
		pageInSize: number,
		sort: string,
		searchObject: string | object
	): Observable<PaginationResult<T>> {
		const url = this.apiUrl + '/page?page=' + pageNumber + '&size=' + pageInSize + '&sort=' + sort;
		return this._restClientService.post(url, JSON.stringify(searchObject)).pipe(catchError(this.handleError));
	}
}
